import { createElement, forwardRef } from 'react';
import ErrorBoundary from './ErrorBoundary';
import { getIsSsr } from 'utils/environment';

export function withErrorBoundary(component) {
  if (!component.displayName && typeof window !== 'undefined') {
    const errorMessage = `All components should have displayName property asigned. Please asign displayName for ${component.name} Component`;

    if (getIsSsr()) {
      window.console.error(errorMessage);
    } else {
      throw new Error(errorMessage);
    }
  }
  const name = component.displayName || 'Unknown Component';

  const Wrapped = forwardRef((props, ref) =>
    createElement(
      ErrorBoundary,
      { wrappedComponentName: name },
      createElement(component, { ...props, ref }),
    ),
  );

  // Format for display in DevTools
  Wrapped.displayName = `withErrorBoundary(${name})`;

  return Wrapped;
}
